<template>
  <span class="animatedNumber">
    {{ number === null ? '-' : displayNumber }}</span
  >
</template>

<script>
export default {
  name: 'AnimatedNumber',
  props: {
    number: { type: Number, default: null },
  },
  data() {
    return {
      animatedNumber: 0,
    };
  },
  computed: {
    displayNumber() {
      return Number(this.animatedNumber.toFixed(0)).toLocaleString();
    },
  },
  watch: {
    number(newValue) {
      // gasp added using CDN external link in index.html
      // eslint-disable-next-line no-undef
      gsap.to(this.$data, { duration: 0.5, animatedNumber: newValue });
    },
  },
  mounted() {
    if (this.number !== null) {
      this.animatedNumber = this.number;
    }
  },
};
</script>

<style></style>
